import GUARANTEES from './views/guarantees.c';

export default GUARANTEES;
